import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { GeneralService } from '../../services/general.service';
import { TableComponent } from '../../components/table/table.component';
import { PaginationComponent } from '../../utilities/pagination/pagination.component';
import { RelayService } from '../../services/relay.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { SideModalComponent } from '../../components/side-modal/side-modal.component';
import { ButtonComponent } from "../../utilities/button/button.component";
import { PermissionService } from '../../services/permissions.service';
import { ModalComponent } from "../../components/modal/modal.component";

@Component({
  selector: 'app-relay',
  standalone: true,
  imports: [
    DashboardComponent,
    CommonModule,
    DropdownComponent,
    TableComponent,
    PaginationComponent,
    SideModalComponent,
    ButtonComponent,
    ModalComponent
],
  templateUrl: './relay.component.html',
  styleUrl: './relay.component.scss',
})
export class RelayComponent {
  relayType: any = ['ALL', 'INBOUND', 'OUTBOUND'];
  queryType: string = '';
  createRelayTypes: any = ['INBOUND', 'OUTBOUND'];
  currentRelayType: string = 'ALL';
  fetchingData: boolean = false;
  tableHeader: any[] = [];
  tableData: any[] = [];
  filterData: any[] = [];
  relayDetailsOpen: boolean = false;
  singleRelay: any;
  limit: number = 10;
  loading: boolean = false;
  page: number = 1;
  fromDate: any;
  deleteId: string = '';
  relays: any;
  totalRelays: number = 0;
  totalPages: number = 0;
  toDate: any;
  deleteModalOpen: boolean = false;
  emptyTableState = {
    title: 'No data found',
    label: 'You have no relays',
  };
  canWrite = false;
  canDelete = false;
  canUpdate = false;
  constructor(
    private generalService: GeneralService,
    private relayService: RelayService,
    private notification: NzNotificationService,
    private permissionService: PermissionService
  ) {
    this.getRelays();
    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.filterData = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'channel',
        label: 'Channel',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'wallet', value: 'Wallet' },
          { key: 'card', value: 'Card' },
          { key: 'ussd', value: 'Ussd' },
          { key: 'loyaltyCard', value: 'Loyalty Card' },
          { key: 'onlineTransfer', value: 'Online Transfer' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-type',
        label: 'Transaction Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'funding', value: 'Funding' },
          { key: 'withdrawal', value: 'Withdraw' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-status',
        label: 'Transaction Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'failed', value: 'Failed' },
          { key: 'success', value: 'Success' },
          { key: 'pending', value: 'Pending' },
        ],
      },
      {
        type: 'select',
        name: 'transaction-initiator',
        label: 'Transaction Initiator',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'company', value: 'Company' },
          { key: 'customer', value: 'Customer' },
        ],
      },
    ];
  }
  ngOnInit() {
    this.canWrite = this.permissionService.hasPermission('Write');
    this.canDelete = this.permissionService.hasPermission('Delete');
    this.canUpdate = this.permissionService.hasPermission('Update');
    console.log(this.canDelete, this.canWrite, this.canUpdate);
  }
  openDeleteModal(id: string){this.deleteModalOpen = true; this.deleteId = id}
  closeDeleteModal(){this.deleteModalOpen = false}
  openRelayDetails(id: string) {
    this.relayDetailsOpen = true;
    this.singleRelay = this.relays.find((obj: any) => obj._id === id);
    console.log(this.singleRelay);
  }
  closeRelayDetails() {
    this.relayDetailsOpen = false;
  }
  setRelayType(type: string) {
    this.currentRelayType = type;
    this.getRelays();
// if(type === 'Inbound'){
//   this.tableData = this.relays
//   .filter((relay: any) => relay.type === 'INBOUND')
//   .map((relay: any, n: number) => {
//     return [
//       {
//         name: {
//           title: relay.name,
//           // label: this.generalService.formatDate(relay.createdAt),
//         },
//         ratio: { width: '33%', minWidth: '180px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span class="capitalize font-[500]">${relay.destinationDomain}</span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span>${relay._id}&nbsp;</span><span></span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//     ];
//   });
// }
// if(type === 'Outbound'){
//   this.tableData = this.relays
//   .filter((relay: any) => relay.type === 'OUTBOUND')
//   .map((relay: any, n: number) => {
//     return [
//       {
//         name: {
//           title: relay.name,
//           // label: this.generalService.formatDate(relay.createdAt),
//         },
//         ratio: { width: '33%', minWidth: '180px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span class="capitalize font-[500]">${relay.destinationDomain}</span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span>${relay._id}&nbsp;</span><span></span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//     ];
//   });
// }
// if(type === 'All'){
//   this.tableData = this.relays.map((relay: any, n: number) => {
//     return [
//       {
//         name: {
//           title: relay.name,
//           // label: this.generalService.formatDate(relay.createdAt),
//         },
//         ratio: { width: '33%', minWidth: '180px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span class="capitalize font-[500]">${relay.destinationDomain}</span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//       {
//         name: {
//           title: `<span>${relay._id}&nbsp;</span><span></span>`,
//         },
//         ratio: { width: '33%', minWidth: '50px' },
//         id: relay._id,
//       },
//     ];
//   });
// }
  }
  navigateToCreate(type: any) {
    this.generalService.routeTo(`relay/create/${type}`);
  }
  navigateToEdit(id: any){
    this.generalService.routeTo(`relay/edit/${id}`);
  }
  addSpaceAfterComma(arr: any): any[] {
    return arr.map((str: any) => str.replace(/,/g, ', '));
  }
  copyText(text: string){this.generalService.copyText(text); this.notification.info('Copied to clipboard', '', {
    nzClass: 'notification',
  });}
  manageRoute(data: any) {}
  search(value: any) {}
  changeLimit(limit: any) {}
  applyFilter(data: any) {}
  refreshList() {}
  deleteRelay(){}

  getRelays() {
    this.fetchingData = true;
    if(this.currentRelayType === 'ALL'){
      this.queryType = ''
    }else {this.queryType = this.currentRelayType}
    this.relayService.getRelays(this.queryType).subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        console.log(res);
        this.limit = res?.pagination?.limit;
        this.page = res?.pagination?.page;
        this.totalRelays = res?.pagination?.total;
        this.totalPages = res?.pagination?.pages;
        this.relays = res.data;
        this.tableHeader = [
          { name: 'Relay Name', ratio: { width: '33%', minWidth: '204px' } },
          {
            name: 'Destination Domain',
            ratio: { width: '33%', minWidth: '83px' },
          },
          { name: 'Relay ID', ratio: { width: '33%', minWidth: '83px' } },
        ];
        this.tableData = this.relays.map((relay: any, n: number) => {
          return [
            {
              name: {
                title: relay.name,
                // label: this.generalService.formatDate(relay.createdAt),
              },
              ratio: { width: '33%', minWidth: '180px' },
              id: relay._id,
            },
            {
              name: {
                title: `<span class="capitalize font-[500]">${relay.destinationDomain}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: relay._id,
            },
            {
              name: {
                title: `<span>${relay._id}&nbsp;</span><span></span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: relay._id,
            },
          ];
        });
      },
      error: (err) => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to get reward types', {
          nzClass: 'notification',
        });
      },
    });
  }
  deleteApi = () => {
    this.loading = true;
    this.relayService.deleteRelay(this.deleteId).subscribe({
      next: (res: any) => {
        this.deleteModalOpen = false;
        this.loading = false;
        this.notification.success('Success', 'Relay Deleted', {
          nzClass: 'notification',
        });
        this.getRelays();
      },
      error: (err) => {
        console.log(err);
        this.deleteModalOpen = false;
        this.loading = false;
      },
    });
  };
}
